import PropTypes from 'prop-types';
import React from 'react';
import Title from './title.jsx';

export default class Embed extends React.Component {
    static displayName = 'Embed';

    static propTypes = {
        content: PropTypes.any,
    };

    render() {
        const { embed_html, title, url } = this.props.content;
        const pageTitle = `${title} (${url})`;

        return (
            <div>
                <Title>{pageTitle}</Title>
                <div className="embedded-content-container media-content">
                    {/* always generate a new div when the html changes */}
                    <div
                        key={embed_html}
                        className="embedded-content-wrapper"
                        dangerouslySetInnerHTML={{ __html: embed_html }}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/embed_link.jsx